import React from 'react'
import { URL_SRV_RAIZ } from '../router/Url';

export default function MakeMeAFile({PLANTA,DESDE,HASTA,TURNO}){
  // console.log('Planta =>>>>>', PLANTA,DESDE,HASTA)
  return new Promise(async (resolve, reject) => {
    let query = await fetch(URL_SRV_RAIZ+'makemefile_sotc',{
      method: 'POST',
      headers: {
        'authorization': "marcuxo",
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        PLANTA:PLANTA,
        DESDE:DESDE,
        HASTA:HASTA,
        TURNO:TURNO
      }
      )
    })
    let responsito = await query.json();
    // console.log(responsito)
    if(responsito.success){
      let url = responsito.body;
      let a = document.createElement("a");
      a.href = URL_SRV_RAIZ+url;//to web add url_server+build/
      // console.log(a.href)
      // a.href = url;
      a.download = "ReporteSOTC.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      alert('En instantes se descargara su Archivo')
      resolve(responsito.success)

    }else{
      resolve(responsito.success)
      alert('ups!! Ocurrio un error vuelva a intentarlo.')
    }
  })
}